<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-card class="rounded-lg white">
        <v-card-title class="secondary white--text rounded-lg mb-2">
          <span
              :class="(!isService)?'primary--text font-weight-bold':null"
              @click="setWareTree"
              style="cursor: pointer">
            نمودار درختی کالا
          </span>
          <span class="mr-5 ml-5">
            |
          </span>
          <span
              style="cursor: pointer"
              @click="setServiceTree"
              :class="(isService)?'primary--text font-weight-bold':null">
            نمودار درختی خدمات
          </span>
        </v-card-title>
        <v-card-text>
          <tree-component
            ref="tree"
            :data="root"
            @node-click="setItem"
            @node-context-menu="contextMenu"
            node-text="name"
          />
          <context-menu ref="menu" class="context-menu">
            <template v-if="item">
              <v-card>
                <v-list dense>
                  <v-list-item @click="createChildItem(item)" v-if="item.level != 3">
                    <v-list-item-icon>
                      <v-icon class="pt-1">fas fa-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span>افزودن فرزند</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </template>
          </context-menu>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" md="6">
      <wares-form :is-service="isService" ref="itemForm" :show-list="false" :level="level" class="mt-n3" />
    </v-col>
  </v-row>
</template>

<script>
import TreeComponent from "@/components/tree/Tree";
import wareApiMixin from "@/mixin/wareApi";
import WaresForm from "@/views/panel/ware/Wares";

export default {
  mixins: [wareApiMixin],
  components: { TreeComponent, WaresForm },
  data() {
    return {
      isService: false,
      item: {
        level: 0,
      },
      root: [
        {
          name: "نمودار درختی کالاها و خدمات",
          expanded: true,
          show: true,
          children: [],
        },
      ],
      tree: {},
      parent: null,
      level: 0,
    };
  },
  computed: {
    items() {
      return this.wares.filter(obj => obj.is_service == this.isService);
    },
  },
  created() {
    this.EventBus.$on("get:wares", () => {
      this.updateRoot();
      this.$refs.tree.performSearch(this.$refs.tree.data, "");
    });
    this.getWares();
  },
  methods: {
    setServiceTree() {
      this.isService = true
      this.updateRoot()
      this.$refs.tree.performSearch(this.$refs.tree.data, "");
      this.getWares();
    },
    setWareTree() {
      this.isService = false
      this.updateRoot()
      this.$refs.tree.performSearch(this.$refs.tree.data, "");
      this.getWares();
    },
    setItem(node) {
      if (!node.id) return;
      this.item = { ...node };
      this.parent = null;
      this.level = node.level;
      this.$refs.itemForm.setItem(node);
    },
    contextMenu(node, index, parent, e) {
      if (!node.id) return;
      this.setItem(node);
      this.$refs.menu.open(e);
    },
    updateRoot() {
      this.root[0].children = [];
      let tree = {};
      for (let item of this.items) {
        item.children = [];
        if (this.tree[item.id] && this.tree[item.id].expanded) {
          item.expanded = true;
        }
        tree[item.id] = item;
        if (item.parent) {
          tree[item.parent].children.push(item);
        } else {
          item.show = true;
          this.root[0].children.push(item);
        }

        this.tree = tree;
      }
    },
    createChildItem(node) {
      this.$refs.itemForm.clearForm();
      this.$refs.itemForm.item.parent = node;
      this.level = node.level + 1;
    },
  },
};
</script>

<style lang="scss">
$pad: 30px;
.level-1 td:nth-child(4) {
  padding-right: $pad;
}
.level-2 td:nth-child(4) {
  padding-right: $pad * 2;
}
.level-3 td:nth-child(4) {
  padding-right: $pad * 3;
}
</style>